import React from "react";
import { X } from "lucide-react";

const SwModal = ({
  title,
  subtitle,
  onClose,
  open,
  onSaveChanges,
  saveButtonLoading = false,
  saveButtonText = "Save",
  children,
  width = "524px",
  modalContentStyles,
  modalBodyStyles,
  showSaveButton = true
}) => {
  if (!open) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="sw-modal-overlay" onClick={handleOverlayClick}>
      <div className="sw-modal-content" style={{ width, ...modalContentStyles }}>
        {/* Header */}
        <div className="sw-modal-header">
          <div className="sw-modal-header-content">
            <h2 className="sw-modal-title">{title}</h2>
            {subtitle && <h3 className="sw-modal-subtitle">{subtitle}</h3>}
          </div>
          <button onClick={onClose} className="sw-modal-close-btn">
            <X size={20} />
          </button>
        </div>
        
        {/* Content */}
        <div className="sw-modal-body" style={{ padding: "0px 72px", ...modalBodyStyles }}>
          {children}
        </div>
        
        {/* Footer */}
        {showSaveButton && (
          <div className="sw-modal-footer">
            <button
              onClick={onSaveChanges}
              disabled={saveButtonLoading}
              className={`sw-modal-save-btn ${saveButtonLoading ? 'loading' : ''}`}
            >
              {saveButtonLoading ? "Saving..." : saveButtonText}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SwModal;
